/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable prettier/prettier */
/* eslint-disable no-restricted-globals */
/* eslint-disable import/order */
/* eslint-disable prettier/prettier */
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { FC, useEffect, useState } from 'react';
import { Select2 } from 'libs/common-components';
import { VictimInfoKeys } from '@bvi/api-interfaces/entity/case-property';
import { useFormOptions } from 'libs/form-utils/src';
import { FormProvider, useForm } from 'react-hook-form';
import { Form, PaperModal, SearchTextField } from '@bvi/common-components';
import {
  ManageBaseDataKeys,
  ManageBaseInfoKeys,
} from '@bvi/api-interfaces/entity/manage-base';
import { zodResolver } from '@hookform/resolvers/zod';
import { buildValidationSchema } from '../lib/schema';
import { ManageBaseTable } from './manage-base-table';
import { styles } from './manage-base-table/style';
import { AddManageForm } from './manage-action-menu/add-form';

export const ManageListTab: FC = () => {
  const { t } = useTranslation('translation');

  const genderOptions = useFormOptions(ManageBaseDataKeys, 'manageBase');

  const methods = useForm<any>({
    resolver: zodResolver(buildValidationSchema(t)),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    defaultValues: {
      [ManageBaseInfoKeys.ManageBase]: ManageBaseDataKeys.SUBSIDIARIES,
    },
  });
  const manageBaseValue = methods.watch(ManageBaseInfoKeys.ManageBase);

  const [isModalOpen, setModalOpen] = useState(false);
  const searchMethods = useForm<{ q: string }>({
    defaultValues: { q: '' },
    mode: 'onSubmit',
    reValidateMode: 'onBlur',
  });
  const q = searchMethods.watch('q') ?? '';
  const [debouncedQuery, setDebouncedQuery] = useState('');

  useEffect(() => {
    const id = window.setTimeout(() => {
      setDebouncedQuery(q.trim());
    }, 350);
    return () => window.clearTimeout(id);
  }, [q]);

  return (
    <Box sx={{ my: 3, display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box display="flex" alignItems="center" gap={2} sx={{ mb: 2 }}>
        <Box sx={{ flex: 1 }}>
          <FormProvider {...methods}>
            <Form noValidate>
              <Select2
                name={ManageBaseInfoKeys.ManageBase}
                variant="filled"
                fullWidth
                items={genderOptions}
                label={t('manageBaseInfo.form.manageBase.label')}
                placeholder={t('manageBaseInfo.form.manageBase.placeholder')}
                helperText={
                  (methods.formState.errors[VictimInfoKeys.GENDER]?.message ||
                    '') as unknown as string
                }
                error={Boolean(methods.formState.errors[VictimInfoKeys.GENDER])}
              />
            </Form>
          </FormProvider>
        </Box>
        <Box
          sx={{
            flex: 1,
            paddingTop: '10px',
          }}
        >
          <Typography fontWeight="bold">
            <Box display="flex" alignItems="center">
              <Box sx={{ flex: '1 1 auto' }} />
              <FormProvider {...searchMethods}>
                <Box sx={styles.searchBoxContainer}>
                  <Box sx={styles.searchWrapper}>
                    <SearchTextField
                      field="q"
                      placeholder={
                        t('manageBaseTable.table.search.placeholder') as string
                      }
                      size="small"
                      fullWidth
                      sx={styles.searchField}
                    />
                  </Box>
                </Box>
              </FormProvider>
              <Button
                variant="outlined"
                size="small"
                onClick={() => setModalOpen(true)}
                sx={{ flexShrink: 0 }}
              >
                + {t('manageList.button.add')}{' '}
                {t(`manageBaseInfo.details.options.${manageBaseValue}.label`)}
              </Button>
            </Box>
          </Typography>
        </Box>
      </Box>
      <ManageBaseTable tabValue={manageBaseValue} query={debouncedQuery} />
      <PaperModal open={isModalOpen} onClose={() => setModalOpen(false)}>
        <AddManageForm
          type={manageBaseValue}
          onSuccess={() => setModalOpen(false)}
        />
      </PaperModal>
    </Box>
  );
};
